import * as UserActions from './Users.actions';
import * as ArticleActions from './Articles.actions';

export const ActionCreators: object = Object.assign({}, UserActions, ArticleActions);
